// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../config/styles';

const styles = ({
  mainContainer: {
    width: '100%',
    padding: '10px 0',
  },
  text: {
    display: 'block',
    fontSize: GlobalStyles.fonts.FONT_SIZE,
    color: GlobalStyles.color.COLOR_GREY,
  },
  number: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE,
    color: GlobalStyles.color.COLOR_GREY,
    marginRight: 5,
  },
  regular: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
  },
  bold: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
  },
});

export default styles;
